import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 10.06v1.19c0 .415.335.75.75.75h1.19a2.98 2.98 0 0 0 2.12-.879l4.28-4.28a2.25 2.25 0 0 0 0-3.182 2.25 2.25 0 0 0-3.18 0l-4.281 4.28A2.98 2.98 0 0 0 12 10.061m1.5 0c0-.4.156-.777.44-1.06l4.28-4.28a.75.75 0 1 1 1.06 1.06L15 10.06a1.5 1.5 0 0 1-1.06.44h-.44zm5.25 5.69H18V13.5a.75.75 0 1 0-1.5 0v2.25h-3.75c-1.24 0-2.25 1.01-2.25 2.25v.375c0 .62-.505 1.125-1.125 1.125s-1.125-.505-1.125-1.125V5.625c0-.404-.1-.783-.263-1.125H13.5a.75.75 0 1 0 0-1.5H5.625A2.63 2.63 0 0 0 3 5.625V6c0 1.24 1.01 2.25 2.25 2.25h1.5v10.125A2.63 2.63 0 0 0 9.374 21h9.001A2.63 2.63 0 0 0 21 18.375V18c0-1.24-1.01-2.25-2.25-2.25m-12-9h-1.5A.75.75 0 0 1 4.5 6v-.375c0-.62.505-1.125 1.125-1.125s1.125.505 1.125 1.125zM19.5 18.375c0 .62-.505 1.125-1.125 1.125h-6.629c.163-.341.254-.723.254-1.125V18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75z" }, null, -1)
  ]))]))
}
export default { render: render }